import { map, Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';

/**
 * guards
 */
import { isLoggedInGuard } from './isLoggedIn/is-logged-in.guard';

export const authGuard: CanActivateFn = (route, state) => {
  
  // injects
  const _router = inject(Router);

  const _isLoggedIn$ = isLoggedInGuard(route, state) as Observable<boolean | RedirectCommand>;

  return _isLoggedIn$.pipe(
    map(_isLoggedIn =>  {

      //
      if (_isLoggedIn instanceof RedirectCommand) return true;
      
      return new RedirectCommand(_router.parseUrl('/system'))

    })
  )
};
